export const CRUD_ENTITIES = {
  USER: {
    namespace: 'user',
  },

  STATUS_CATEGORY: {
    namespace: 'statusCategory',
  },
  PAGE: {
    namespace: 'page',
  },
  EMAIL_TEMPLATE: {
    namespace: 'emailTemplate',
  },
  TESTIMONIAL: {
    namespace: 'testimonial',
  },
  BANNER: {
    namespace: 'banner',
  },
  ADVERTISEMENT: {
    namespace: 'advertisement',
  },
  STATE: {
    namespace: 'state',
  },
  CITY: {
    namespace: 'city',
  },

  VENUE: {
    namespace: 'venue',
  },

  USER_BANK: {
    namespace: 'userBank',
  },
  ANCILLARY_SERVICE: {
    namespace: 'ancillaryService',
  },





};
